<script>
	// NPM Modules
	import { createEventDispatcher } from 'svelte';
	// Stores
	import MarketTypeStore from '@/Stores/Sport/MarketTypeStore';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';
	import CheckBox from '@/Components/CheckBox.svelte';
	// Services
	import { notify } from '@/Services/Notify';
	import { SportRollingTypeNames } from '@/Constants/Sport';

	export let sport;
	export let open;

	const dispatch = createEventDispatcher();

	let sending = false;
	let errors = null;

	let marketTypeForm = {
		sport_id: sport.id,
		name: '',
		label: '',
		traded_pre_match: false,
		traded_in_play: false,
		price_order: false,
		rule: '',
		rolling_type_id: null,
		selection_win_limit_factor: '1',
		cashout_enabled: false
	};

	function createMarketType() {
		sending = true;
		MarketTypeStore.createMarketType(marketTypeForm)
			.then(() => {
				notify({
					type: 'success',
					title: 'Manual market type created',
					message: `Manual market type successfully created for ${sport.name}!`,
					timeout: 3
				});
				dispatch('created');
				open = false;
				marketTypeForm = {
					sport_id: sport.id,
					name: '',
					label: '',
					traded_pre_match: false,
					traded_in_play: false,
					rule: '',
					rolling_type_id: null,
					selection_win_limit_factor: '1',
					cashout_enabled: false
				};
			})
			.catch((e) => {
				errors = e;
				notify({
					type: 'danger',
					title: 'Error!',
					message: 'Problem creating manual market type',
					timeout: 3
				});
			})
			.finally(() => (sending = false));
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">
			Create market type for {sport.name}
		</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<TextInput
				label="Name"
				name="marketTypeName"
				required={true}
				className="py-4 w-full text-left"
				errors={errors && errors.name}
				placeholder="Enter market type name"
				bind:value={marketTypeForm.name}
			/>
			<TextInput
				label="Label"
				name="marketTypeLabel"
				required={true}
				className="py-4 w-full text-left"
				errors={errors && errors.label}
				placeholder="Enter market type label"
				bind:value={marketTypeForm.label}
			/>
			<SelectInput
				label="Rolling market type"
				className="py-4 w-full text-left"
				name="marketTypeRollingTypeId"
				bind:value={marketTypeForm.rolling_type_id}
			>
				<option value={null}>Not a rolling market</option>
				{#each Object.entries(SportRollingTypeNames) as [rollingTypeId, rollingTypeName] (rollingTypeId)}
					<option value={rollingTypeId}>{rollingTypeName}</option>
				{/each}
			</SelectInput>
			<div class="py-4 w-full text-left">
				<CheckBox text="Traded Pre-match" bind:checked={marketTypeForm.traded_pre_match} />
			</div>
			<div class="py-4 w-full text-left">
				<CheckBox text="Traded In-play" bind:checked={marketTypeForm.traded_in_play} />
			</div>
			<div class="py-4 w-full text-left">
				<CheckBox text="Show selections in price order" bind:checked={marketTypeForm.price_order} />
			</div>
			<TextInput
				label="Rule"
				name="marketTypeRule"
				className="py-4 w-full text-left"
				errors={errors && errors.rule}
				placeholder="Enter market type rule"
				bind:value={marketTypeForm.rule}
			/>
			<TextInput
				label="Limit factor"
				type="number"
				min="0.1"
				name="selection_win_limit_factor"
				className="py-4 w-full text-left"
				errors={errors && errors.selection_win_limit_factor}
				placeholder="Enter market type limit factor"
				bind:value={marketTypeForm.selection_win_limit_factor}
			/>
			<div class="py-4 w-full text-left">
				<CheckBox text="Cashout enabled" bind:checked={marketTypeForm.cashout_enabled} />
			</div>
			<LoadingButton on:click={() => createMarketType()} loading={sending} className="my-4 btn btn-primary">
				{sending ? 'Creating' : 'Create'}
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}>Cancel</button>
		</div>
	</Modal>
{/if}
